"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rentalAndSocialHousingLoanSchema = void 0;
var transactional_1 = require("../transactional");
var ups_1 = require("../ups");
exports.rentalAndSocialHousingLoanSchema = __assign(__assign({}, transactional_1.transactionalLoanSchema), { required: __spreadArrays(transactional_1.transactionalLoanSchema.required.splice(transactional_1.transactionalLoanSchema.required.indexOf('rentalAndSocialHousingLoanID'), 1)), properties: __assign(__assign({}, transactional_1.transactionalLoanSchema.properties), { rentalAndSocialHousingLoanID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        }, activeLoan: {} }), anyOf: [
        {
            properties: {
                activeLoan: transactional_1.activeLoanSchema,
            },
            required: ['activeLoan'],
        },
        {
            properties: {
                activeLoan: ups_1.intermediateLoanActiveLoanSchema,
            },
            required: ['activeLoan'],
        },
    ] });
